import type { TextAndImageType } from "~/core";

export const isTextAndImage = (item: unknown): item is TextAndImageType => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "text_and_image"
  );
};
